<template>
  <div class="card shadow"
       :class="type === 'dark' ? 'bg-default': ''">
    <div class="card-header border-0"
         :class="type === 'dark' ? 'bg-transparent': ''">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="mb-0" :class="type === 'dark' ? 'text-white': ''">
            {{title}}
          </h3>
          <FactureAddModal v-on:factureadded="reloadData" ></FactureAddModal>
        </div>
      </div>
    </div>
    <div class="table-responsive">
      <transition name="fade">
        <div  v-if="ImpossibleAddFacture" 
              class="alert alert-danger" 
              role="alert">
          Impossible de supprimer cette facture
        </div>
      </transition>
      <center><div v-if="loadingRemoveFacture" class="lds-ring"><div></div><div></div><div></div><div></div></div></center>

      <div class="col-lg-3 float-right">
        <base-input alternative=""
                    placeholder="Rechercher"
                    input-classes="form-control-alternative input_search"
                    v-model="search"
                    @change="searchData"
        />
      </div>
      <base-table class="table align-items-center table-flush"
                  :class="type === 'dark' ? 'table-dark': ''"
                  :thead-classes="type === 'dark' ? 'thead-dark': 'thead-light'"
                  tbody-classes="list"
                  :data="data"
                  :columns="columns"
                  :sortKey.sync="sortKey"
                  :reverse.sync="reverse"
                  @KeyChanged="reloadDataSorted"
                  @reverse="reverseChange"
                  @sortKey="sortKeyChange">
        <template slot="columns">
        </template>

        <template slot-scope="{row}">
          <td>
            {{row.idFacture}}
          </td>
          <td>
            {{row.date}}
          </td>
          <td>
            <a href="#" @click.prevent="DownloadFacture(row.idFacture)">{{row.numero}} <i>({{row.nameFile}})</i></a>
          </td>
          <td>
            {{row.fournisseur_nom}}
          </td>
          <td>
            {{row.montantHT}} {{row.devise_symbole}} HT<br>
            {{row.montantTTC}} {{row.devise_symbole}} TTC
          </td>
          <td>
            {{row.dateReglementMax}}
          </td>
          <td>
            {{row.etatpaiement_label}}
          </td>
          <td>
            {{row.etatreception_label}}
          </td>
          <td>
            <div class="row">
              <FactureEditModal v-on:factureadded="reloadData" 
                                v-bind:facture="row" 
                                v-bind:fournisseur="fournisseur" 
                                v-bind:devise="devise" 
                                v-bind:etatreception="etatreception" 
                                v-bind:etatpaiement="etatpaiement">
              </FactureEditModal>&nbsp;&nbsp;&nbsp;
              <a @click.prevent="deleteFacture($event, row.idFacture)" href="#"><i class="fa fa-trash-alt"></i></a>
            </div>
          </td>

        </template>

      </base-table>
    </div>

    <div class="card-footer d-flex justify-content-end"
         :class="type === 'dark' ? 'bg-transparent': ''">
        <base-pagination 
            :total="total"
            :perPage="perPage"
            @input="changeData"
            :value.sync="value"
            ></base-pagination>
    </div>

  </div>
</template>
<script>
  import constvar from '@/const'
  import _ from 'lodash'
  import router from '@/router'
  import FactureAddModal from '@/components/FactureAddModal'
  import FactureEditModal from '@/components/FactureEditModal'

  export default {
    name: 'factures-table',
    components: {
      FactureEditModal,
      FactureAddModal
    },
    props: {
      type: {
        type: String
      },
      title: String
    },
    data() {
      return { 
        total: 0,
        alldata: [],
        data: [],
        perPage: 10,
        value: 1,
        sortKey: 'idFacture',
        reverse: true,
        search: '',
        columns: [
          ['idFacture','ID'],
          ['date','Date'],
          ['numero','Nom'],
          ['idFournisseur','Fournisseur'],
          ['montantHT','Montant'],
          ['dateReglementMax','Date de réglement maximum'],
          ['idEtatPaiement','Etat Paiement'],
          ['idEtatReception','Etat Réception'],
          ['','']
        ],
        ImpossibleAddFacture:0,
        devise: [],
        fournisseur: [],
        etatpaiement: [],
        etatreception: [],
        loadingRemoveFacture:0,
        
      }
    },
    computed: {
      alldata_filtered: function() { 
        if(this.search != '') {
          return this.alldata.filter(({numero, date, fournisseur_nom, montantHT, dateReglementMax, etatpaiement_label, etatreception_label}) => numero.toLowerCase().includes(this.search.toLowerCase()) || date.toLowerCase().includes(this.search.toLowerCase()) || fournisseur_nom.toLowerCase().includes(this.search.toLowerCase()) || montantHT == this.search || dateReglementMax.toLowerCase().includes(this.search.toLowerCase()) || etatpaiement_label.toLowerCase().includes(this.search.toLowerCase()) || etatreception_label.toLowerCase().includes(this.search.toLowerCase()));
        } else {
          return this.alldata;
        }
      }
    },
    async created() {
        const response = await fetch(constvar.api_url+'facture', {
        method: 'GET',
        credentials: 'include',
        });
        if(response.ok) { 
            const json = await response.json();
            //check if api return regenerated token
            if(json.code != 409) {
                this.alldata = json;
                this.changeData(1);
                this.total = this.alldata_filtered.length;
            } else { 
                router.push("login")    
            }
        }const devise = await fetch(constvar.api_url+'devise', {
            method: 'GET',
            credentials: 'include',
        });
        if(devise.ok) { 
            const devisejson = await devise.json();
            if(devisejson.code != 409) {
                this.devise = devisejson;
            } else { 
                router.push("login")    
            }
        } 
        const fournisseur = await fetch(constvar.api_url+'fournisseur', {
            method: 'GET',
            credentials: 'include',
        });
        if(fournisseur.ok) { 
            const fournisseurjson = await fournisseur.json();
            if(fournisseurjson.code != 409) {
                this.fournisseur = fournisseurjson;
            } else { 
                router.push("login")    
            }
        } 
        const etatreception = await fetch(constvar.api_url+'etatreception', {
            method: 'GET',
            credentials: 'include',
        });
        if(etatreception.ok) { 
            const etatreceptionjson = await etatreception.json();
            if(etatreceptionjson.code != 409) {
                this.etatreception = etatreceptionjson;
            } else { 
                router.push("login")    
            }
        } 
        const etatpaiement = await fetch(constvar.api_url+'etatpaiement', {
            method: 'GET',
            credentials: 'include',
        });
        if(etatpaiement.ok) { 
            const etatpaiementjson = await etatpaiement.json();
            if(etatpaiementjson.code != 409) {
                this.etatpaiement = etatpaiementjson;
            } else { 
                router.push("login")    
            }
        } 
    },
    methods: {
        sortTableData: function() {
          this.alldata.forEach(function(element) {
            element.idFacture = Number(element.idFacture);
            element.idFournisseur = Number(element.idFournisseur);
            element.idEtatPaiement = Number(element.idEtatPaiement);
            element.idEtatReception = Number(element.idEtatReception);
            element.montantHT = Number(element.montantHT);
            element.montantTTC = Number(element.montantTTC);
          })
          return _.orderBy(this.alldata_filtered, this.sortKey, (this.reverse) ? 'desc' : 'asc')
        },
        changeData: function(e) {
            let page = e;
            let perPage = this.perPage;
            let from = (page * perPage) - perPage;
            let to = (page * perPage);
            let tableData = this.sortTableData();
            this.data = tableData.slice(from, to);
            this.value = page;
        },
        reloadDataSorted: function() {
          this.changeData(this.value);
        },
        sortKeyChange: function(e) {
          this.sortKey = e;
        },
        reverseChange: function(e) {
          this.reverse = e;
        },
        searchData: function() {
        },
        reloadData: async function() {
          const response = await fetch(constvar.api_url+'facture', {
          method: 'GET',
          credentials: 'include',
          });
          if(response.ok) { 
              const json = await response.json();
              //check if api return regenerated token
              if(json.code != 409) {
                  this.alldata = json;
                  this.changeData(1)
                  this.total = this.data.length;
              } else { 
                  router.push("login")    
              }
          } 
        },
        DownloadFacture: async function(idFacture) {
            const factureentiere = await fetch(constvar.api_url+'facture/'+idFacture, {
              method: 'GET',
              credentials: 'include',
            });
            if(factureentiere.ok) { 
              let factureentierejson = await factureentiere.json();
              if(factureentierejson.idFacture == idFacture) {
                const linkSource = `data:application/pdf;base64,`+factureentierejson.contentFile;
                const downloadLink = document.createElement("a");
                const fileName = factureentierejson.nameFile;

                downloadLink.href = linkSource;
                downloadLink.download = fileName;
                downloadLink.click();
              } else { 
                router.push("login")    
              }
            } 
        },
        deleteFacture: async function(event, idFacture) {
          var self = this;
          let options = {
              okText: 'Confirmer',
              cancelText: 'Annuler',
          };
          this.$dialog
          .confirm('Êtes vous sûr de vouloir supprimer cette facture ?', options)
          .then(async function() {
            self.loadingRemoveFacture = 1;
            const response = await fetch(constvar.api_url+'facture/'+idFacture, {
            method: 'DELETE',
            credentials: 'include',
            });
            if(response.ok) { 
                const json = await response.json();
                //check if api return regenerated token
                self.loadingRemoveFacture = 0;
                if(json.rows == 1) {
                    self.reloadData();
                } else if(json.rows == -1) {
                    self.ImpossibleAddFacture = true
                    setTimeout(()=>{
                      self.ImpossibleAddFacture = false
                    },1500);
                } else { 
                    router.push("login")    
                }
            } 
          })
        },
    },
    watch: {
      alldata_filtered: function() {
        this.changeData(this.value);
      }
    },
  }
</script>
<style>
</style>
